export type TimeFrame = typeof TIMEFRAMES[number];

export const TIMEFRAMES = [
    { 
        "iD": 1, 
        "name": "Second",
    },
    { 
        "iD": 2, 
        "name": "Minute",
    },
    { 
        "iD": 3, 
        "name": "Hour",
    },
    { 
        "iD": 4, 
        "name": "Day",
    },
    { 
        "iD": 5, 
        "name": "Week",
    },
    { 
        "iD": 6, 
        "name": "Month",
    },
    { 
        "iD": 7, 
        "name": "Year",
    },
] as const;